import { useNavigate } from "react-router-dom";

export function Banner() {
  return (
    <section className="banner">
      <img src="./images/banner5.png" alt="Баннер" draggable="false" />
      <h2 className="banner-text">
        20 сезон "Epilogue" — открытие 17 июля 19:00 МСК
        <a style={{"marginLeft": "30px", "cursor": "pointer"}} className="button" href="/donate">
          Купить донат
        </a>
      </h2>
    </section>
  );
}
